/* eslint-disable ts/ban-ts-comment */
/* eslint-disable unicorn/number-literal-case */
/* eslint-disable unicorn/prefer-number-properties */
// @ts-nocheck

import { sha256 } from '../../sha256'

import _0x4e2179 from './key1'
import _0x1c7b4d from './key2'
import _0x461862 from './key3'
import _0xebdb2 from './salt'
;(function (_0x5338c1, _0x131b21) {
  const _0x5413ce = _0xef31
  const _0x43a2b6 = _0x5338c1()
  while ([]) {
    try {
      const _0x23766f =
        (parseInt(_0x5413ce(0x108)) / 0x1) * (parseInt(_0x5413ce(0xfe)) / 0x2) +
        (-parseInt(_0x5413ce(0x105)) / 0x3) *
          (parseInt(_0x5413ce(0x10a)) / 0x4) +
        (parseInt(_0x5413ce(0x104)) / 0x5) *
          (-parseInt(_0x5413ce(0x102)) / 0x6) +
        parseInt(_0x5413ce(0x109)) / 0x7 +
        (-parseInt(_0x5413ce(0xff)) / 0x8) *
          (parseInt(_0x5413ce(0x106)) / 0x9) +
        -parseInt(_0x5413ce(0x100)) / 0xa +
        (-parseInt(_0x5413ce(0x103)) / 0xb) *
          (-parseInt(_0x5413ce(0x101)) / 0xc)
      if (_0x23766f === _0x131b21) {
        break
      } else {
        _0x43a2b6.push(_0x43a2b6.shift())
      }
    } catch (_0x478c24) {
      _0x43a2b6.push(_0x43a2b6.shift())
    }
  }
})(_0x19d9, 0x7dd1c)
function _0xef31(_0x2c2b2a, _0x4c5964) {
  const _0x19d9dd = _0x19d9()
  return (
    (_0xef31 = function (_0xef312c, _0x209e2f) {
      _0xef312c = _0xef312c - 0xfe
      const _0x160949 = _0x19d9dd[_0xef312c]
      return _0x160949
    }),
    _0xef31(_0x2c2b2a, _0x4c5964)
  )
}
function _0x19d9() {
  const _0x46bb66 = [
    '584486RUrOMM',
    '4lkMnxJ',
    'default',
    '52yYGEJU',
    '936792nmXsPX',
    '2277740TKCmCQ',
    '11861796aSOWvH',
    '6wtDPba',
    '33WdJhyt',
    '5020855SJcsLw',
    '2944131lvQxZx',
    '45oVXPVG',
    'join',
    '10201nnisXh',
  ]
  _0x19d9 = function () {
    return _0x46bb66
  }
  return _0x19d9()
}
function customJoin(_0xf95de9) {
  const _0x6fdda = _0xef31
  return _0xf95de9[_0x6fdda(0x107)]('')
}
export async function sigV1(_0x74eb7c) {
  const _0x5e8f60 = _0xef31
  const _0x9c9fad = (await import('md5'))[_0x5e8f60(0x10b)]
  const _0x40d9fd = _0x9c9fad(customJoin([_0x4e2179, _0x1c7b4d, _0x461862]))
  const _0x36386e = await sha256(customJoin([_0x40d9fd, _0x74eb7c, _0xebdb2]))
  return { deviceNumber: _0x36386e, version: 'v1' }
}
